import { render, staticRenderFns } from "./Amenitites.vue?vue&type=template&id=b03054dc&"
import script from "./Amenitites.vue?vue&type=script&lang=js&"
export * from "./Amenitites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports